export default __webpack_public_path__ + "static/media/Resources.7c2783a3.png";